module.exports = __webpack_public_path__ + "img/ic_dc.e7862f8a.png";